<template>
    <div class="content with-pagination">
        <router-view @refresh="refresh()"></router-view>
        <header class="content-header">
            <div class="wrapper">

                <div>
                    <h1>Scopes</h1>
                    <p>Gestion des worspaces de connexion</p>

                    <div class="datagrid-results"><strong>{{paginator.total}}</strong> Résultats trouvés</div>
                </div>

              <actions-dropdown>
                <li v-if="$aclInterfaceValidator('weeboxcore.scope.create')" class="main" @click="create()">
                  <icon name="file-plus-02"/>
                  <span>Créer un scope</span>
                </li>
              </actions-dropdown>

            </div>
        </header>
        <div class="content-body">

            <section>

                <no-results v-model="resources" :clear="resetFilter"></no-results>

            <div v-if="resources && resources.length" class="datagrid" :class="paginator.listing">
                <div class="datagrid-header">
                    <div>
                        <div></div>
                        <div class="picture"></div>
                        <div>
                          <datagrid-sort :data="[{name:'Nom', value:'name'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="slug center">
                          <datagrid-sort :data="[{name:'Référence', value:'slug'}]" v-model="paginator"></datagrid-sort>
                        </div>
                        <div class="parent center">Parent scope</div>
                        <div class="timezone center">Timezone</div>
                        <div class="actions"></div>
                        <div></div>
                    </div>
                </div>
                <div class="datagrid-body">
                    <div v-for="item in resources" @dblclick="edit(item.id)">
                        <div></div>
                        <div class="picture">
                            <figure>
                                <i v-if="!item.picture" class="icon icon-icon_layers"></i>
                                <img v-if="item.picture" :src="item.picture.url+'/fit/100x100'"/>
                            </figure>
                        </div>
                        <div data-field="name"><strong class="highlight">{{ item.name }}</strong><p>{{ item.description }}</p></div>
                        <div data-field="slug" class="center"><label class="label scope" v-bind:style="{background:item.color}">{{ item.slug.substr(0,1) }}</label></div>
                        <div data-field="parent" class="center"><label class="label scope" v-if="item.parent" v-bind:style="{background:item.parent.color}">{{ item.parent.slug.substr(0,1) }}</label></div>
                        <div data-field="timezone" class="center">{{ item.timezone }}</div>
                        <div class="actions">
                            <ul>
                                <li><button @click="remove(item.id)"><icon name="trash-01"/></button></li>
                                <li><button @click="edit(item.id)"><icon name="pencil-02"/></button></li>
                            </ul>
                        </div>
                        <div></div>
                    </div>
                </div>
            </div>
            </section>

            <component-paginator v-model="paginator" v-on:refresh="refresh"></component-paginator>

        </div>
    </div>
</template>
<script>
    import ScopeService from './ScopeService.js';
    import Index from '../../layouts/Index.vue';

    export default {
        extends: Index,
        data () {
            return {
            }
        },
        mounted: function(){
            this.refresh()
        },
        methods: {
            getResource: function(){
                return ScopeService;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/scope/Index.vue